<template>
  <section class="notFoundCnt" v-on:click="sectionClicked"
    :class="{loading: loading}">
    <Header :class="{scrolled: isScrolled}" ref="header"/>
    <div class="notFound" v-if="!loading">
      <h2>Unsubscribe Email</h2>
      <p>Kamu telah berhasil unsubscribe dari sistem email Team Up For Impact</p>
      <a href="/" class="btn">Kembali Ke Halaman Depan</a>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'notFound',
  components: { Header },
  data() {
    return {
      isScrolled: false,
      loading: true,
    };
  },
  methods: {
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.sectionClicked();
    },
    scrolled() {
      this.isScrolled = window.scrollY > 30;
    },
  },
  created() {
    document.addEventListener('scroll', this.scrolled);
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrolled);
  },
  mounted() {
    const { key } = this.$route.query;
    setTimeout(() => {
      this.$http.post(this.$config.uri('misc/email/unsubscribe'), { key }).then((r) => {
        if (r.data.status !== 200) {
          window.location.href = '/';
          return;
        }
        this.loading = false;
      });
    }, 1000);
  },
};
</script>

<style scoped lang="scss">
.notFoundCnt{
  position: relative;
  height: 100vh;
  &.loading{
    background-image: url(../assets/loading.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 46px auto;
  }
  .notFound{
    position: absolute;
    left: 40px; right: 40px;
    top: 50%; transform: translateY(-50%);
    margin-top: 20px;
    text-align: center;
    color: #767676;
    img{
      height: auto;
      width: 100%;
      max-width: 500px;
      margin-bottom: 40px;
    }
    h2{
      margin: 0 0 10px;
      font-size: 30px;
      line-height: 1;
    }
    p{
      margin: 0 0 20px;
    }
  }
}
</style>
